module.exports = __webpack_public_path__ + "img/hospital.b0b47af0.png";